export default __webpack_public_path__ + "static/media/avatar_mice6.1a6d0d78.mp3";